import { useTranslation } from "react-i18next";

const stroke = "#003FB1";

const nodeSvg = {
  width: 44,
  height: 44,
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": true,
};

const moduleSvg = { ...nodeSvg, width: 34, height: 34 };

// Order matches platformArchitecture.modules in the locale files.
const moduleIconTypes = [
  "provisioning",
  "pricing",
  "customers",
  "analytics",
  "billing",
  "api",
];

// Order matches platformArchitecture.reach in the locale files.
const reachIconTypes = ["tower", "globe"];

function ArchitectureIcon({ type, size = "node" }) {
  const common = size === "module" ? moduleSvg : nodeSvg;

  if (type === "business") {
    return (
      <svg {...common}>
        <path
          d="M7 34V10a2 2 0 0 1 2-2h11a2 2 0 0 1 2 2v24M22 34V18h9a2 2 0 0 1 2 2v14"
          stroke={stroke}
          strokeWidth="1.75"
          strokeLinejoin="round"
        />
        <path
          d="M11 14h3M11 19h3M11 24h3M17 14h1M17 19h1M17 24h1M26 23h3M26 28h3M5 34h30"
          stroke={stroke}
          strokeWidth="1.75"
          strokeLinecap="round"
        />
      </svg>
    );
  }

  if (type === "tower") {
    return (
      <svg {...common}>
        <path
          d="M20 14v20M16 34h8"
          stroke={stroke}
          strokeWidth="1.75"
          strokeLinecap="round"
        />
        <circle cx="20" cy="11" r="2.5" stroke={stroke} strokeWidth="1.75" />
        <path
          d="M14.5 16.5a7 7 0 0 1 0-11M25.5 5.5a7 7 0 0 1 0 11M10.5 20a12 12 0 0 1 0-18M29.5 2a12 12 0 0 1 0 18"
          stroke={stroke}
          strokeWidth="1.75"
          strokeLinecap="round"
        />
      </svg>
    );
  }

  if (type === "device") {
    return (
      <svg {...common}>
        <rect
          x="12"
          y="5"
          width="16"
          height="30"
          rx="3"
          stroke={stroke}
          strokeWidth="1.75"
        />
        <path
          d="M18 8h4"
          stroke={stroke}
          strokeWidth="1.75"
          strokeLinecap="round"
        />
        <path
          d="M20 15v10M16.5 18.5a5 5 0 0 1 7 0M14.5 15a8 8 0 0 1 11 0"
          stroke={stroke}
          strokeWidth="1.6"
          strokeLinecap="round"
        />
      </svg>
    );
  }

  if (type === "globe") {
    return (
      <svg {...common}>
        <circle cx="20" cy="20" r="14" stroke={stroke} strokeWidth="1.75" />
        <ellipse cx="20" cy="20" rx="6" ry="14" stroke={stroke} strokeWidth="1.75" />
        <path d="M6 20h28M8 14h24M8 26h24" stroke={stroke} strokeWidth="1.75" />
      </svg>
    );
  }

  if (type === "provisioning") {
    return (
      <svg {...common}>
        <circle cx="20" cy="20" r="5" stroke={stroke} strokeWidth="1.75" />
        <path
          d="M20 4.5v4M20 31.5v4M4.5 20h4M31.5 20h4M9 9l2.8 2.8M28.2 28.2 31 31M31 9l-2.8 2.8M11.8 28.2 9 31"
          stroke={stroke}
          strokeWidth="1.75"
          strokeLinecap="round"
        />
        <circle cx="20" cy="20" r="12" stroke={stroke} strokeWidth="1.6" />
      </svg>
    );
  }

  if (type === "pricing") {
    return (
      <svg {...common}>
        <circle cx="20" cy="20" r="13" stroke={stroke} strokeWidth="1.75" />
        <path
          d="M20 12v16M23.5 15.5c-.9-1.2-2.1-1.8-3.5-1.8-2.2 0-4 1.4-4 3.2s1.8 3.2 4 3.2 4 1.4 4 3.2-1.8 3.2-4 3.2c-1.4 0-2.6-.6-3.5-1.8"
          stroke={stroke}
          strokeWidth="1.75"
          strokeLinecap="round"
        />
      </svg>
    );
  }

  if (type === "customers") {
    return (
      <svg {...common}>
        <circle cx="15" cy="14" r="5" stroke={stroke} strokeWidth="1.75" />
        <path
          d="M5 32c0-5.5 4.5-10 10-10s10 4.5 10 10"
          stroke={stroke}
          strokeWidth="1.75"
          strokeLinecap="round"
        />
        <path
          d="M26 10.5a5 5 0 0 1 0 9M28 22.6c4 1.2 7 4.9 7 9.4"
          stroke={stroke}
          strokeWidth="1.75"
          strokeLinecap="round"
        />
      </svg>
    );
  }

  if (type === "analytics") {
    return (
      <svg {...common}>
        <rect
          x="6"
          y="6"
          width="28"
          height="28"
          rx="4"
          stroke={stroke}
          strokeWidth="1.75"
        />
        <path
          d="M13 26v-6M20 26v-12M27 26v-8"
          stroke={stroke}
          strokeWidth="1.75"
          strokeLinecap="round"
        />
      </svg>
    );
  }

  if (type === "billing") {
    return (
      <svg {...common}>
        <path
          d="M9 5h16l6 6v24H9z"
          stroke={stroke}
          strokeWidth="1.75"
          strokeLinejoin="round"
        />
        <path d="M24 5v7h7" stroke={stroke} strokeWidth="1.75" strokeLinejoin="round" />
        <circle cx="20" cy="23" r="5" stroke={stroke} strokeWidth="1.6" />
        <path
          d="M20 20v6M18.5 21.5h3M18.5 24.5h3"
          stroke={stroke}
          strokeWidth="1.5"
          strokeLinecap="round"
        />
      </svg>
    );
  }

  // api
  return (
    <svg {...common}>
      <path
        d="M14 12 6 20l8 8M26 12l8 8-8 8M22.5 9 17.5 31"
        stroke={stroke}
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function FlowArrow() {
  return (
    <span className="platform-architecture-arrow" aria-hidden="true">
      <svg width="34" height="12" viewBox="0 0 34 12" fill="none">
        <path
          d="M1 6h30M26 1.5 31.5 6 26 10.5"
          stroke={stroke}
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
}

function PlatformArchitecture() {
  const { t } = useTranslation();
  const modules = t("platformArchitecture.modules", { returnObjects: true });
  const reach = t("platformArchitecture.reach", { returnObjects: true });

  return (
    <section className="platform-architecture-section py-50">
      <div className="container">
        <div className="platform-architecture-panel">
          <div className="platform-architecture-head">
            <h2 className="platform-architecture-title">
              {t("platformArchitecture.title")}
            </h2>
            <p className="platform-architecture-subtitle">
              {t("platformArchitecture.subtitle")}
            </p>
          </div>

          <div className="platform-architecture-flow">
            <article className="platform-architecture-node">
              <span className="platform-architecture-node-icon">
                <ArchitectureIcon type="business" />
              </span>
              <h3 className="platform-architecture-node-title">
                {t("platformArchitecture.business")}
              </h3>
            </article>

            <FlowArrow />

            <div className="platform-architecture-core">
              <p className="platform-architecture-core-label">
                {t("platformArchitecture.platform")}
              </p>
              <div className="platform-architecture-modules">
                {modules.map((item, index) => (
                  <div className="platform-architecture-module" key={item}>
                    <span className="platform-architecture-module-icon">
                      <ArchitectureIcon
                        type={moduleIconTypes[index]}
                        size="module"
                      />
                    </span>
                    <span className="platform-architecture-module-label">
                      {item}
                    </span>
                  </div>
                ))}
              </div>
            </div>

            <FlowArrow />

            <article className="platform-architecture-node">
              <span className="platform-architecture-node-icon">
                <ArchitectureIcon type="tower" />
              </span>
              <h3 className="platform-architecture-node-title">
                {t("platformArchitecture.connectivity")}
              </h3>
            </article>

            <FlowArrow />

            <article className="platform-architecture-node">
              <span className="platform-architecture-node-icon">
                <ArchitectureIcon type="device" />
              </span>
              <h3 className="platform-architecture-node-title">
                {t("platformArchitecture.endUser")}
              </h3>
              <p className="platform-architecture-node-subtitle">
                {t("platformArchitecture.endUserSubtitle")}
              </p>
            </article>
          </div>

          <div className="platform-architecture-reach">
            {reach.map((item, index) => (
              <div className="platform-architecture-reach-item" key={item}>
                <span className="platform-architecture-reach-pill">
                  <ArchitectureIcon
                    type={reachIconTypes[index]}
                    size="module"
                  />
                  {item}
                </span>
              </div>
            ))}
          </div>
        </div>

        <p className="platform-architecture-note">
          {t("platformArchitecture.note1")}
        </p>
        <p className="platform-architecture-note">
          {t("platformArchitecture.note2")}
        </p>
      </div>
    </section>
  );
}

export default PlatformArchitecture;
